import type {
  PutTranscriptionConfigRequest,
  RedactionCategory,
  RetentionPeriodUnit,
  TranscriptionConfig,
} from "../../../types/transcription/TranscriptionConfig";

export const REDACTION_CATEGORIES: RedactionCategory[] = [
  "Financial",
  "Personal",
];

export const RETENTION_PERIOD_UNITS: RetentionPeriodUnit[] = [
  "Days",
  "Months",
  "Years",
];

export interface CategoryFormValue {
  category: RedactionCategory;
  enabled: boolean;
  tags: string[];
}

export interface RuleFormValue {
  category: RedactionCategory;
  durationAfterStartDate: number;
  unit: RetentionPeriodUnit;
}

export interface TranscriptionConfigFormValues {
  categories: CategoryFormValue[];
  rules: RuleFormValue[];
}

export function toFormValues(
  config: TranscriptionConfig,
): TranscriptionConfigFormValues {
  const categories = REDACTION_CATEGORIES.map((category) => {
    const option = config.redactionOptions.find(
      (o) => o.category === category,
    );
    return {
      category,
      enabled: option != null,
      tags: option?.tags ?? [],
    };
  });

  const rules = [...config.retentionRules]
    .sort((a, b) => a.priority - b.priority)
    .map((rule) => ({
      category: rule.category,
      durationAfterStartDate: rule.retainFor.durationAfterStartDate,
      unit: rule.retainFor.unit,
    }));

  return { categories, rules };
}

export function toPutRequest(
  customerId: string,
  values: TranscriptionConfigFormValues,
): PutTranscriptionConfigRequest {
  return {
    customerId,
    redactionOptions: values.categories
      .filter((c) => c.enabled)
      .map(({ category, tags }) => ({ category, tags })),
    retentionRules: values.rules.map((rule, index) => ({
      category: rule.category,
      priority: index + 1,
      retainFor: {
        durationAfterStartDate: Number(rule.durationAfterStartDate),
        unit: rule.unit,
      },
    })),
  };
}
